import type { IconData } from '@stacksjs/iconify-core'

export const lens: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M24 16a8 8 0 1 1 0 16a8 8 0 0 1 0-16\"/><path d=\"M16 24c0-12 4-20.5 4-20.5M32 24c0 12-4 20.5-4 20.5m-8-27.428c10.393-6 19.754-6.786 19.754-6.786M28 30.928c-10.393 6-19.754 6.786-19.754 6.786M20 30.928c-10.393-6-15.754-13.714-15.754-13.714M28 17.072c10.393 6 15.754 13.714 15.754 13.714\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default lens
